import useData from "../../assets/hooks/useData"
import SidePanel from "./SidePanel/SidePanel"
import Cirkelvisualisatie from "./Cirkelvisualisatie/Cirkelvisualisatie"

import CalculatePositions from "../../noncomponents/CalculatePositions"
import CalculateConnectionChains from "../../noncomponents/CalculateConnectionChains"
import CalculateLinkPathsPerIcon from "../../noncomponents/CalculateLinkPathsPerIcon"
// import HillClimber from "../../noncomponents/HillClimber"
// import setLandschapAndPartijen from "../../noncomponents/setLandschapAndPartijen"

import { useState, useRef, useMemo } from 'react';
import * as d3 from "d3";

function Content({ settings }) {

  // an icon is selected
  const [clickSelection, setClickSelection] = useState(-1);
  // the current impact chain that is selected
  const [chainSelection, setChainSelection] = useState(-1);
  // current icon that is hovered
  const [hoverSelection, setHoverSelection] = useState(-1);
  // depth of connections that is shown
  const [depth, setDepth] = useState(10);
  // currently shown dropwdown options for landschapstypes
  const [landschapOptions, setLandschapOptions] = useState([ 'Droogmakerij', 'Zeekleipolder', 'Rivierengebied', 'Dekzandgebied', 'Stuwwal', 'Heuvelland', 'Laagveen', 'Rivierterrassen', 'Kust', 'Keileemgebied', 'Voormalige hoogvenen']);
  // currently shown dropwdown options for betrokken partijen
  const [partijenOptions, setPartijenOptions] = useState(['RWS', 'Waterschap', 'Provincie', 'Privaat', 'Drinkwaterbedrijf', 'Gemeente']);

  const data = useData();

  // this function can be fired from many files. It resets all states to the
  // starting state. Usually it is fired when a white area with no objects is
  // clicked
  function chartClicked(){
    d3.selectAll('image').classed('selected', false)

    // setLandschapAndPartijen(data, connectionChains.current, -1,
    //   setLandschapOptions, setPartijenOptions, true);

    setHoverSelection(-1);
    // TODO: wordt dit wel uitgevoerd?
    setClickSelection(-1);
    setChainSelection(-1);

  }

  // berekeningen van de juiste afmetingen van de visualisatie
  const divSysteemEnImpacts = document.querySelector('.Content');
  const circleWidth = (divSysteemEnImpacts !== null)
    ? d3.min([divSysteemEnImpacts.offsetWidth/37, divSysteemEnImpacts.offsetHeight/20])
    : 0;
  const middleRadius = circleWidth*1.7;
  const circleWidthImpacts = circleWidth + 6;

  // hier worden alle berekeningen 1x gedaan die wat langer kunnen duren
  const iconPositions = useRef([]);
  const connectionChains = useRef([]);
  const linkPathsPerIcon = useRef([]);
  useMemo(() => {
    // iconPositions.current = HillClimber(data, CalculatePositions(data, middleRadius, circleWidth))
    iconPositions.current = CalculatePositions(data, middleRadius, circleWidth, circleWidthImpacts);
    connectionChains.current = CalculateConnectionChains(data, depth);
    linkPathsPerIcon.current = CalculateLinkPathsPerIcon(data, iconPositions.current,
      connectionChains.current, circleWidth/2);
    // setLandschapAndPartijen(data, connectionChains, chainSelection,
      // setLandschapOptions, setPartijenOptions, true);
  }, [data, middleRadius, circleWidth, depth])



  return (
    <div className="Content">

      <Cirkelvisualisatie settings={settings} data={data}
        clickSelection={clickSelection} setClickSelection={setClickSelection}
        linkPathsPerIcon={linkPathsPerIcon.current} iconPositions={iconPositions.current}
        connectionChains={connectionChains.current} middleRadius={middleRadius}
        circleWidth={circleWidth} chainSelection={chainSelection}
        setChainSelection={setChainSelection} chartClicked={chartClicked}
        hoverSelection={hoverSelection} setHoverSelection={setHoverSelection}
        circleWidthImpacts={circleWidthImpacts}
        partijenOptions={partijenOptions} landschapOptions={landschapOptions}
        setPartijenOptions={setPartijenOptions} setLandschapOptions={setLandschapOptions} />

      <SidePanel data={data} clickSelection={clickSelection} setDepth={setDepth}
        connectionChains={connectionChains.current}
        setClickSelection={setClickSelection} setChainSelection={setChainSelection}
        chainSelection={chainSelection} chartClicked={chartClicked}
        partijenOptions={partijenOptions} setPartijenOptions={setPartijenOptions}
        landschapOptions={landschapOptions} setLandschapOptions={setLandschapOptions} />


    </div>
  );
}

export default Content;
